<div 
        class="numeric-container" 
        [class.disabled]="isDisabled()"
        [class.focused]="isFocused()"
        [class.align-left]="align() === 'left'"
        [class.align-center]="align() === 'center'"
        [class.align-right]="align() === 'right'"
        [tabindex]="isDisabled() ? -1 : 0"
        (click)="setFocus()"
        (focus)="onContainerFocus($event)"
        (blur)="onContainerBlur($event)"
        >
        
        @if (isFocused() && !isDisabled()) {
          <input
            #inputRef
            type="text"
            [value]="displayValue()"
            (input)="handleInput($event)"
            (blur)="onBlur()"
            (keydown)="handleKeyDown($event)"
            class="ghost-input"
            [class.align-left]="align() === 'left'"
            [class.align-center]="align() === 'center'"
            [class.align-right]="align() === 'right'"
            (focus)="onInputFocus()"
            autocomplete="new-password"
            name="numeric-input-field"
            [attr.data-form-type]="'other'"
          />
        } @else {
          <span 
            class="display-text"
            [class.align-left]="align() === 'left'"
            [class.align-center]="align() === 'center'"
            [class.align-right]="align() === 'right'"
          >{{ formattedValue() }}</span>
        }
      </div>